import { Injectable } from '@angular/core';
import { BehaviorSubject,fromEvent} from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

/**
 * Service to provide window size information
 */
@Injectable({
  providedIn: 'root'
})
export class WindowSizeService {
  private widthSubject: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerWidth);
  public width$ = this.widthSubject.asObservable();
  private heightSubject: BehaviorSubject<number> = new BehaviorSubject<number>(window.innerWidth);
  public height$ = this.heightSubject.asObservable();
  constructor() { 
    fromEvent(window, 'resize', { passive: true }).pipe(
      debounceTime(20),
      distinctUntilChanged(),
      tap(() => {
        this.widthSubject.next(window.innerWidth);
        this.heightSubject.next(window.innerHeight);
        //console.log ('WindowSizeService', window.innerWidth, window.innerHeight);
      }),
    ).subscribe();

  }
}